import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { format } from "date-fns";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { OrganizationTaskTemplateRow } from "../organizationTaskTemplatesViewConfig";
import { getOrganizationTaskTemplatesTableMeta } from "../organizationTaskTemplatesTableMeta";

export const OrganizationTaskTemplateCreatedCell = memo(
    function OrganizationTaskTemplateCreatedCell({
        row,
        table,
    }: CellContext<ViewTableFeatures, OrganizationTaskTemplateRow, string>) {
        const meta = getOrganizationTaskTemplatesTableMeta(table);
        const createdAt = meta?.templatesById.get(row.original.id)?.createdAt;

        return (
            <ViewTableCell>
                <span>
                    {createdAt ? format(createdAt, "MMM d, yyyy") : "-"}
                </span>
            </ViewTableCell>
        );
    },
);
